export const items = <const>['all', 'certificates', 'learning'];

export type ItemsType = (typeof items)[number];
